var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvatar2 = function SvgAvatar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatar-2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C400",
    d: "M60 30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#794B37",
    d: "M12.03 44.358c10.452-.92 22.547-1.338 33.037-1.075l2.903 2.37s-.718 2.184-1.54 3.44c-.19.29-.39.59-.683.772-.315.197-.697.24-1.067.277-6.378.64-12.788.945-19.195.915-4.13-.02-8.768-.404-11.468-3.53l-1.982-3.17h-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M31.13 43.333h-2.258V9.795a.855.855 0 0 1 1.71-.015l.55 33.553h-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.96 10.613c-.133-.26-.525-.158-.515.135.325 9.595.295 19.19.652 28.784.013.323.03.67.173.92.182.323.508.383.797.416 4.075.444 8.19.184 12.223-.776-2.45-8.005-3.295-9.454-6.945-17.064l-6.387-12.415h.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D73823",
    d: "M41.502 29.665c-.663-1.46-1.433-3.055-2.438-5.14-2.734.09-5.597.098-7.314.095.03 1.793.06 3.582.092 5.375 2.275.08 6.413-.128 9.657-.33h.003ZM31.6 16.475c.04 1.795.075 3.592.105 5.387 1.53.03 3.837-.102 5.91-.257l-2.658-5.165c-1.265.03-2.457.035-3.357.035ZM44.527 37.657c-.665-2.074-1.223-3.66-1.805-5.124-3.685.234-8.708.237-10.825.227.04 1.785.09 3.568.15 5.352 2.617.173 8.992-.215 12.478-.455h.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.572 20.635c.175-.248.565-.115.55.19-.32 6.773-.295 13.543-.652 20.315-.013.23-.03.477-.175.655-.185.23-.515.273-.81.295a51.533 51.533 0 0 1-11.965-.48.308.308 0 0 1-.218-.457 263.996 263.996 0 0 1 10.27-16.268l2.998-4.25h.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D73823",
    d: "M21.623 29.3a255.844 255.844 0 0 0-2.463 3.832c2.963.173 6.925.355 8.593.228.032-1.332.065-2.668.095-4-1.188.005-3.738.008-6.225-.06ZM17.835 35.26a253.777 253.777 0 0 0-2.293 3.785c2.24.152 10.126.657 12.008.375.058-1.32.105-2.64.145-3.96-1.188.008-6.44.035-9.86-.2ZM27.9 27.27c.035-1.337.072-2.675.122-4.015-.535.003-1.355.005-2.295-.008l-1.152 1.636c-.513.75-1.02 1.502-1.523 2.255 1.84.12 3.795.204 4.85.13l-.002.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatar-2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export { SvgAvatar2 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-2.d0dbca4950bc329f84f7.svg";